import { render } from "./changeButton.vue?vue&type=template&id=904105e2"
import script from "./changeButton.vue?vue&type=script&lang=js"
export * from "./changeButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__